<template>
  <vs-popup class=" user-edit-popup"
            id="popup"
            title="USER UPDATE"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickUpdateStaffUser)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="title" name="title" rules="required" v-slot="{ errors }">
                <small class="label">Title</small>
                <v-select :clearable="false" placeholder="" v-model="selectedStaff.title" :reduce="option => option" :options="['Mr.','Mrs.','Miss']" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="first_name" name="first_name" rules="required" v-slot="{ errors }">
                <small class="label">First Name</small>
                <vs-input v-model="selectedStaff.first_name"  name="first_name" class="w-full required" label=""/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="last_name" name="last_name" rules="required" v-slot="{ errors }">
                <small class="label">Last Name</small>
                <vs-input v-model="selectedStaff.last_name"  name="last_name" class="w-full required" label=""/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col  md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="email" name="email" rules="required" v-slot="{ errors }">
                <small class="label">Email</small>
                <vs-input  v-model="selectedStaff.email" class="w-full"  name="email" type="email" label="" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full md:mb-0">
              <ValidationProvider vid="user_group" name="user_group" rules="required" v-slot="{ errors }">
                <small class="label">User Role</small>
                <v-select name="user_group" :reduce="option => option.id" :closeOnSelect="true" v-model="selectedStaff.role_id"  :options="roles" label="name" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="country_code_mobile" name="country_code_mobile" rules="required" v-slot="{ errors }">
                <small class="label">Country Code</small>

                <v-select :filter-by="countryCodeFilter" :clearable="false" placeholder="country code" label="isd_code" v-model="selectedStaff.country_code_mobile" :reduce="option => option.isd_code" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template v-slot:option="option">
                    <span>{{option.isd_code}} - {{option.name}} </span>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="mobile" name="mobile" rules="contactNumber|min_tel|max_tel|required" v-slot="{ errors }">
                <small class="label">Mobile</small>
                <vs-input v-model="selectedStaff.mobile" class="w-full"  name="mobile" type="text" label="" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="country_code_telephone" name="country_code_telephone" rules="required" v-slot="{ errors }">
                <small class="label">Country Code Telephone</small>
                <v-select :filter-by="countryCodeFilter" :clearable="false" placeholder="country code telephone" label="isd_code" v-model="selectedStaff.country_code_telephone" :reduce="option => option.isd_code" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template v-slot:option="option">
                    <span>{{option.isd_code}} - {{option.name}} </span>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="telephone" name="telephone" rules="contactNumber|min_tel|max_tel|required" v-slot="{ errors }">
                <small class="label">Telephone</small>
                <vs-input v-model="selectedStaff.telephone" class="w-full"  name="telephone" type="text" label="" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-8">
            <div class="vx-col md:w-full md:mb-0">
              <small class="label">Enable 2FA?</small>
              <vs-switch @input="onChange2FA()" v-model="selectedStaff.is_google_2fa_enable" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </div>
          </div>
          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="onClickReset" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
    <two-f-a-pop-up v-on:refreshData="refreshData()" ref="twoFAPopUp"/>
    <vs-prompt
      @cancel="onClick2FADisableCancel"
      @accept="onClick2FADisable"
      @close="onClick2FADisableCancel"
      title="Confirm"
      accept-text="Disable"
      color="danger"
      :active.sync="active2FADisabledPrompt">
      <div class="con-exemple-prompt">
        <span>Enter your password</span>
        <vs-input type="password" v-model="password" class="mt-3 w-full" />
      </div>
    </vs-prompt>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const UserRepository = RepositoryFactory.get('user')
  const RolesRepository = RepositoryFactory.get('roles');
  const CountryCodeRepository = RepositoryFactory.get('countryCode');
  import vSelect from 'vue-select'
  import SuccessMessage from "@/mixins/SuccessMessage";
  import ErrorMessages from "@/mixins/ErrorMessages";

  import TwoFAPopUp from "@/components/popups/user-settings/TwoFAPopUp";

  function initialState() {
    return {
      open: false,
      id: '',
      roles: [],
      role: {},
      countryCodes:{},
      selectedStaff: {},
      updateStaffSelected: [],
      active2FADisabledPrompt: false,
      password: '',
    }
  }

export default {
  name: 'UpdateStaffPopUp',
  data () {
    return initialState()
  },
  mixins: [SuccessMessage, ErrorMessages],
  methods:{
    async openPopup (id) {
      try {
        await Object.assign(this.$data, initialState())
        this.open = true;
        this.id = id
        await this.loadRoles();
        await this.getStaff();
        await this.loadCountryCodes();
      } catch (error) {
        this.convertAndNotifyError(error)
      }
    },
    async refreshData() {
      await this.getStaff()
      await this.$parent.refreshData()
    },
    async onClickUpdateStaffUser() {
      const vue = this;
      this.$vs.loading()
     try {
       await UserRepository.updateUser(this.selectedStaff.id, this.selectedStaff)
       this.showSuccessMessage('User updated successfully')
       await vue.$parent.refreshData()
       this.open = false;
     } catch (e) {
       this.convertAndNotifyError(e)
     }
      this.$vs.loading.close()
    },
    async onChange2FA() {
      if(this.selectedStaff.is_google_2fa_enable) {
        await this.$refs.twoFAPopUp.openPopup(this.id)
      } else {
        this.open = false
        this.active2FADisabledPrompt = true
      }
    },
    onClick2FADisableCancel() {
      this.password = ''
      this.active2FADisabledPrompt = false
      this.open = true
      this.selectedStaff.is_google_2fa_enable = !this.selectedStaff.is_google_2fa_enable
    },
    async onClick2FADisable() {
      this.$vs.loading()
      try {
        await UserRepository.disable2FA({ password: this.password }, this.id)
        this.showSuccessMessage('2FA disabled successfully')
        await this.refreshData()
      } catch (e) {
        await this.refreshData()
        this.convertAndNotifyError(e)
      }
      this.password = ''
      this.$vs.loading.close()
      this.open = true
    },
    async loadRoles() {
      this.roles = [];
      this.$vs.loading();
      const {data} = await RolesRepository.get(' ', '', '', '' )
      this.roles =  data.data
      this.$vs.loading.close()
    },
    async getStaff() {
      this.$vs.loading();
      const { data } = await UserRepository.getUser(this.id)
      this.selectedStaff = data.data
      this.selectedStaff.role_id = data.data.role.id
      this.$vs.loading.close()
    },
    async loadCountryCodes(){
      this.$vs.loading()
      const {data} = await CountryCodeRepository.get()
      this.countryCodes = data.data
      this.$vs.loading.close()
    },
    countryCodeFilter: (option, label, search) => {
      let temp = search.toLowerCase();
      return option.name.toLowerCase().indexOf(temp) > -1 ||
        option.isd_code.toLowerCase().indexOf(temp) > -1
    },
    async onClickReset() {
      await this.getStaff();
    }
  },
  async mounted () {

  },
  components: {
    'v-select': vSelect,
    TwoFAPopUp,
  }
}
</script>

<style scoped>
  .video-wrapper {
    width: 100%;
    height: 100%;
  }

  .video-wrapper video {
    object-fit: cover;
    width: 100%;
    height: 100%;

  }
  .image-wrapper {
    width: 100%;
    height: 75%;
  }


</style>
